import { useTranslate } from "../contexts/translate";
import { Background } from "../components/ui/Background";
import { BigButton } from "../components/ui/BigButton";
import { IonContent } from "@ionic/react";
import { Header } from "../components/ui/Header";

const Home: React.FC = () => {
  const { translate } = useTranslate();
  return (
    <>
      <Header size="small" />
      <IonContent>
        <Background
          background="home"
          style={{
            paddingTop: "calc(5 * var(--u))",
          }}
        >
          <BigButton
            icon="cards"
            label={translate("screens.home.entryCards")}
            to="/cards"
          />
          <BigButton
            icon="dice"
            label={translate("screens.home.entryDices")}
            to="/dices"
          />
          <BigButton
            icon="howto"
            label={translate("screens.home.entryHowTo")}
            to="/help"
          />
          <BigButton
            icon="credits"
            label={translate("screens.home.entryCredits")}
            to="/credits"
          />
        </Background>
      </IonContent>
    </>
  );
};

export default Home;
